import { Action, createReducer, on } from '@ngrx/store';
import { StatusBarData } from '../shared/models/status-bar-data';
import * as MessageHubActions from '../../../state/actions/message-hub.actions';

export interface LobbyStatusBarState {
    statusBarData: StatusBarData;
}

const initialLobbyStatusBarState: LobbyStatusBarState = {
    statusBarData: {
        visitorsWaiting: 0,
        avgWaitTime: 0,
        visitorServed: 0,
        staffSignedIn: 0,
        hourlyWaitCounts: []
    }
};

const reducer = createReducer<LobbyStatusBarState>(
    initialLobbyStatusBarState,
    on(MessageHubActions.receivedStatBarData, (lobbyStatusBarState, action): LobbyStatusBarState => (
        {
            ...lobbyStatusBarState,
            statusBarData: action.messageData ? JSON.parse(action.messageData) : null
        }
    ))
);

export function lobbyStatusBarReducer(state: LobbyStatusBarState | undefined, action: Action) {
    return reducer(state, action);
}
